export const searched = (e, items, name) => {
  let value = e.target.value;

  let filtered = items.filter(item => item[name].toLowerCase().indexOf(value.toLowerCase()) !== -1);

  return filtered;
};
